import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { useInsider } from "@faire/retailer-visitor-shared/hooks/retailer/useInsider";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import { useMemo } from "react";
export var useSearchPageFilteredFilterSections = function() {
    var shouldShowInsider = useInsider().shouldShowInsider;
    var _useFilterStore = useFilterStore([
        "filterSections"
    ]), filterSections = _useFilterStore.data.filterSections;
    return useMemo(function() {
        if (!filterSections) {
            return [];
        }
        var filterSectionsWithoutInsider = filterSections.filter(function(s) {
            return s.field_name !== IFilterSection.FieldName.INSIDER;
        });
        return shouldShowInsider ? filterSections : filterSectionsWithoutInsider;
    }, [
        filterSections,
        shouldShowInsider
    ]);
};
